import {
  AccountSummary,
  AccountTradingPlanStatusEnum,
  TradingAccountStatusesEnum,
} from '../../models/crm/types';
import { NullableNumber, NullableString } from '../../util/types';

export type AccountHistory = {

  tradingPlanIdsHeld: number[];
  lastClosedAccount: {
    accountId: number;
    tradingPlanId: NullableNumber;
    planStatus: AccountTradingPlanStatusEnum;
  } | null;
  cashAccountByTradingAccount: Record<string, NullableString>;
};

export const EMPTY_ACCOUNT_HISTORY: AccountHistory = {
  tradingPlanIdsHeld: [],
  lastClosedAccount: null,
  cashAccountByTradingAccount: {},
};

const isTradingAccount = (account: AccountSummary): boolean => !account.is_cash_account;

const isClosed = (account: AccountSummary): boolean =>
  account.account_status === TradingAccountStatusesEnum.Closed;

const byHighestAccountId = (
  highest: AccountSummary | undefined,
  account: AccountSummary,
): AccountSummary => (highest && highest.account_id > account.account_id ? highest : account);

export const toAccountHistory = (accounts: AccountSummary[]): AccountHistory => {
  const tradingAccounts = (accounts ?? []).filter(isTradingAccount);
  const lastClosed = tradingAccounts.filter(isClosed).reduce<AccountSummary | undefined>(
    byHighestAccountId,
    undefined,
  );

  const cashAccountByTradingAccount = tradingAccounts.reduce<Record<string, NullableString>>(
    (result, account) => ({ ...result, [account.reference_id]: account.cash_account_reference_id }),
    {},
  );

  return {
    tradingPlanIdsHeld: tradingAccounts
      .map(account => account.trading_plan_id)
      .filter((planId): planId is number => planId != null),
    lastClosedAccount: lastClosed
      ? {
        accountId: lastClosed.account_id,
        tradingPlanId: lastClosed.trading_plan_id,
        planStatus: lastClosed.account_trading_plan_status,
      }
      : null,
    cashAccountByTradingAccount,
  };
};
